import $ from 'cash-dom';
import {headerComponent} from "./components/header";
import {sliderInputComponent} from "./components/sliderInput";
import {animeFloatComponent} from "./components/animeFloat";
import {formComponent} from "./components/form";
import {validate} from "./systems/validate";
import {phoneInputComponent} from "./components/phoneInput";
import {emailInputComponent} from "./components/emailInput";
import {cardComponent} from "./components/card";
import {calculatorContactComponent} from "./components/calculatorContact";
import {calculateApi} from "./api/calculate";
import {storageSystem} from "./systems/storage";
import {format} from "./systems/format";
import {anchorScrollComponent} from "./components/anchorScroll";

import "./bootstrap";
import anime from "animejs";
import {stepsComponent} from "./components/steps";
import {popupComponent} from "./components/popup";
import {errorComponent} from "./components/error";
import {licensePlateInputComponent} from "./components/licensePlateInput";
import {postalCodeInputComponent} from "./components/postalCodeInput";
import {calculatePzpApi} from "./api/calculatePzp";
import {pzpAddressInputComponent} from "./components/pzpAddressInput";

const storage = storageSystem('calculator-pzp').createItems([
    'initialValues',
    'sortOrdering',
]);
const indexContactStorage = storageSystem('index-contact').createItems([
    'email',
    'phone'
]);

$(document).ready(() => {
    const initialValues = storage.initialValues.get({
        license_plate: '',
        vehicle_type: 'personal',
        postal_code: '',
        // accident_insurance: false,
        email: indexContactStorage.email.get(''),
        phone: indexContactStorage.phone.get(''),
        should_send_offer: false,
        agree_personal_information: false,
    });
    const initialSortOrdering = storage.sortOrdering.get('rate');

    const defaultConfig = {
        loanAmount: {
            min: 15e3,
            max: 400e3,
            step: 1e3,
            defaultValue: initialValues.loan_amount,
        },
        loanDuration: {
            min: 1,
            max: 30,
            step: 1,
            defaultValue: initialValues.loan_duration,
        },
    };
    const errorMessages = {
        license_plate: {message: 'ŠPZ nemá správny formát', root: '#license-plate-input'},
        vehicle_type: {message: '', root: ''},
        postal_code: {message: 'PSČ má nesprávny formát', root: '#postal-code-input'},
        // accident_insurance: '',
        should_send_offer: '',
        email: {message: 'E-mailová adresa nemá správny formát', root: '#email-input'},
        phone: {message: 'Telefónne číslo je nesprávne', root: '#phone-input'},
        agree_personal_information: {
            message: 'Musíte súhlasiť so spracovaním osobných údajov',
            root: '#agree_personal_information-input'
        },

        door_count: {message: 'Počet dverí musí byť číslo', root: '#door_count-input'},
        first_registration: {message: 'Pole musí byť dátum alebo rok', root: '#first_registration-input'},
        driven_km: {message: 'Počet najazdených kilometrov musí byť číslo', root: '#driven_km-input'},
        no_incident_period: {message: '', root: '#no_incident_period-input'},
        start_date: {message: 'Začiatok poistenia musí byť dátum', root: '#start_date-input'},

        individual_first_name: {message: 'Meno je povinné', root: '#individual_first_name-input'},
        individual_last_name: {message: 'Priezvisko je povinné', root: '#individual_last_name-input'},
        individual_identification_card: {message: 'Číslo občianskeho preukazu musí byť vo formáte XX000000', root: '#individual_identification_card-input'},
        individual_identification_number: {message: 'Rodné číslo musí mať správny formát bez lomky', root: '#individual_identification_number-input'},
        individual_street: {message: 'Pole je povinné', root: '#individual_street-input'},
        individual_house_number: {message: 'Pole je povinné', root: '#individual_house_number-input'},
        individual_postal_id: {message: '', root: '#individual_postal_id-input'},
        individual_city_id: {message: '', root: '#individual_city_id-input'},
        individual_postal_city: {message: 'PSČ a obec musia byť zvolené zo zoznamu', root: '#individual_postal_city-input'},
        individual_region_id: {message: '', root: '#individual_region_id-input'},
        individual_region: {message: 'Pole je povinné', root: '#individual_region-input'},
        individual_country: {message: 'Pole je povinné', root: '#individual_country-input'},
        individual_driver_licence_year: {message: 'Začiatok poistenia musí byť dátum', root: '#individual_driver_licence_year-input'},
};

    let results;

    animeFloatComponent();
    headerComponent();
    anchorScrollComponent();
    cardComponent();
    errorComponent();
    licensePlateInputComponent('#license-plate-input', {defaultValue: initialValues.license_plate});
    postalCodeInputComponent('#postal-code-input', {defaultValue: initialValues.postal_code});
    emailInputComponent('#email-input', {defaultValue: initialValues.email});
    phoneInputComponent('#phone-input', {defaultValue: format.view.phone(initialValues.phone)});
    const contactPopup = popupComponent('#contact-popup');
    const successPopup = popupComponent('#success-popup');
    $(`#vehicle_type_${initialValues.vehicle_type}`).get(0).checked = true;
    // $('#accident_insurance').get(0).checked = initialValues.accident_insurance;
    $('#agree_personal_information').get(0).checked = initialValues.agree_personal_information;
    $('#should_send_offer').get(0).checked = initialValues.should_send_offer;

    const resultsContainer = $('#results-container').get(0);
    // const resultsOrdering = $('#results_ordering').get(0);
    const renderResults = async (data, results) => {
        // const sorted = results.sort((a, b) => a[resultsOrdering.value] - b[resultsOrdering.value]);
        const sorted = results;

        const [contentDesktop] = await Promise.all([
            calculatePzpApi.view('additional-info', sorted),
        ]);

        resultsContainer.innerHTML = contentDesktop;

        anchorScrollComponent(resultsContainer);
        additionalInfoForm();
        // return updateSteps(data, results);
    };

    const updateResults = async (data) => {
        results = await calculatePzpApi(data);
        console.log(results);

        if (!results || !results.success)
            return null;

        /*
                window.dataLayer.push({
                    'event': 'pzp_calculator_request',
                    'should_send_offer': data.should_send_offer,
                    'agree_personal_information': data.agree_personal_information,
                });
        */

        return renderResults(data, results);
    };

    const onSubmit = async (data) => {
        console.log(data);

        await updateResults(data);
        storage.initialValues.set(data);

        window.dataLayer.push({
            event: 'pzp_krok_1',
        });
        window.hj('event', 'pzp_krok_1');

        $('#calculator-form').find('.error').each((i, e) => e.style.display = 'none');
        const targets = window.document.scrollingElement || window.document.body || window.document.documentElement;
        anime({
            targets,
            scrollTop: $('#results-container').offset().top,
            duration: 500,
            easing: 'easeInSine',
        });
    };

    const onErrors = errors => {
        Object.entries(errors).forEach(([field, isValid]) => {
            const errorMessage = errorMessages[field];

            if (!errorMessage) {
                console.warn('Missing error for field', field);
                return;
            }

            if (errorMessage.root) {
                const $ele = $(errorMessage.root);
                const error = $ele.find('.error').get(0);
                const errorContent = $ele.find('.error-content').get(0);

                if (!isValid) {
                    error.style.display = 'flex';
                    errorContent.innerText = errorMessage.message;
                } else {
                    error.style.display = 'none';
                }
            }
        });
    };

    const {
        any,
        integer,
        date,
        year,
        required,
        licensePlate,
        idCardNumber,
        idNumber,
        email,
        phone,
        postalCode,
        postalCity,
        cond,
        or,
    } = validate;

    /*
        resultsOrdering.onchange = () => {
            storage.sortOrdering.set(resultsOrdering.value);
            renderResults(form.getValues(), results);
        };
    */

    const form = formComponent(
        '#calculator-form',
        {
            fields: [
                {
                    name: 'license_plate',
                    type: 'licensePlate',
                    validate: licensePlate(),
                    onValid(value) {
                        $('#license_plate').val(format.view.licensePlate(value));
                    },
                },
                {name: 'vehicle_type', type: 'text', validate: any()},
                {name: 'postal_code', type: 'postalCode', validate: postalCode()},
                // {name: 'accident_insurance', type: 'checkbox', validate: any()},
                {name: 'should_send_offer', type: 'checkbox', validate: any()},
                {
                    name: 'email',
                    type: 'text',
                    validate: email(),
                    onValid(value) {
                        $('#contact-email').val(value);
                    },
                },
                {
                    name: 'phone',
                    type: 'phone',
                    validate: phone(),
                    onValid(value) {
                        $('#contact-phone').val(format.view.phone(value));
                    },
                },
                {name: 'agree_personal_information', type: 'checkbox', validate: required()},
            ],
            onSubmit,
            onErrors,
        }
    );

    $('.contact-popup-show').on('click', (e) => {
        contactPopup.show();
    });

    const extendOnInput = (...names) => (value, {name, validate}) => {
        const $el = $([name, ...names].map(name => `#${name}-input .validate-correct`).join(', '));

        if (validate(value))
            $el.removeClass('opacity-0');
        else
            $el.addClass('opacity-0');
    };

    const onInput = extendOnInput()
    // resultsOrdering.value = initialSortOrdering;
    // updateResults(initialValues);

    const additionalInfoForm = () => {
        // $('#had_pzp-yes').get(0).checked = true;
        // $('#wants_sales-yes').get(0).checked = true;

        const renderResults = async (data, results) => {
            // const sorted = results.sort((a, b) => a[resultsOrdering.value] - b[resultsOrdering.value]);
            const sorted = results;

            const [contentDesktop] = await Promise.all([
                calculatePzpApi.view('vehicle-owner', sorted),
            ]);

            resultsContainer.innerHTML = contentDesktop;

            anchorScrollComponent(resultsContainer);
            vehicleOwnerForm();
            // return updateSteps(data, results);
        };

        formComponent(
            '#additional-info-form',
            {
                fields: [
                    {name: 'door_count', type: 'text', validate: integer(0, 100), onInput},
                    {name: 'first_registration', type: 'text', validate: or(date(), year()), onInput},
                    {name: 'driven_km', type: 'text', validate: integer(0, 1e6), onInput},
                    {name: 'had_pzp', type: 'text', validate: any()},
                    {name: 'no_incident_period', type: 'text', validate: any(), onInput},
                    {name: 'payment_frequency', type: 'text', validate: any(), onInput},
                    {name: 'start_date', type: 'text', validate: date(), onInput},
                    // {name: 'wants_sales', type: 'text', validate: any()},
                ],
                onSubmit: async (data) => {
                    console.log(data);
                    try {
                        await calculatePzpApi.additionalInfo(data);
                    } catch (e) {
                        const data = e.response.data;
                        console.info('errors', data['errors']);
                        if (data['errors']) {
                            $(`#additional-info-form`)
                                .find('.error')
                                .removeClass('flex')
                                .addClass('hidden');

                            Object.entries(data['errors']).forEach(([name, error]) => {
                                $(`#${name}-input`).find('.error')
                                    .removeClass('hidden')
                                    .addClass('flex')
                                    .find('.error-content')
                                    .text(error);
                                console.log(name, error, $(`#${name}-input`).find('.error').get());
                            });
                        }

                        return;
                    }

                    window.dataLayer.push({
                        event: 'pzp_krok_2',
                    });
                    window.hj('event', 'pzp_krok_2');

                    return renderResults(data);
                },
                onErrors: errors => {
                    Object.entries(errors).forEach(([field, isValid]) => {
                        const errorMessage = errorMessages[field];

                        if (!errorMessage) {
                            console.warn('Missing error for field', field);
                            return;
                        }

                        if (errorMessage.root) {
                            const $ele = $(errorMessage.root);
                            const error = $ele.find('.error').get(0);
                            const errorContent = $ele.find('.error-content').get(0);

                            try {
                                if (!isValid) {
                                    error.style.display = 'flex';
                                    errorContent.innerText = errorMessage.message;
                                } else {
                                    error.style.display = 'none';
                                }
                            } catch (e) {
                                console.error('Failed updating error component for field', field);
                            }
                        }
                    });
                },
            }
        );
    }

    const vehicleOwnerForm = () => {
        let category = 'individual';
        $('button[data-category]').on('click', function () {
            const selectedClass = "border-blue-dark bg-blue-dark text-white";
            const notSelectedClass = "border-blue-light";

            $('button[data-category]').removeClass(selectedClass).addClass(notSelectedClass);
            $(this).removeClass(notSelectedClass).addClass(selectedClass);

            category = $(this).data('category');

            $('#individual, #entrepreneur, #entity').addClass('hidden').removeClass('flex');
            $(`#${category}`).removeClass('hidden').addClass('flex');
            const errors = form.validate(form.getValues());
            form.fields.forEach(field => {
                if (field.onInput)
                    field.onInput(form.getValues()[field.name], field);
            });
            console.log('values', form.getValues());
        });

        // $('#individual_insurance_contract-yes').get(0).checked = true;
        $('#individual_same_address-yes').get(0).checked = true;
        $('#entrepreneur_vat-no').get(0).checked = true;
        // $('#entrepreneur_insurance_contract-yes').get(0).checked = true;
        $('#entrepreneur_same_address-yes').get(0).checked = true;
        $('#entity_vat-no').get(0).checked = true;
        // $('#entity_insurance_contract-yes').get(0).checked = true;
        $('#entity_same_address-yes').get(0).checked = true;

        const renderResults = async (data, results) => {
            // const sorted = results.sort((a, b) => a[resultsOrdering.value] - b[resultsOrdering.value]);
            const sorted = results;

            resultsContainer.innerHTML = loadingTemplate;
            window.location.hash = 'results-container';
            anchorScrollComponent(resultsContainer);

            const onUpdate = () => {
                $('.toggle-additional').each((id, el) => {
                    const $el = $(el);
                    const $target = $('#' + $el.attr('data-target-id'));
                    const $overlay = $('#' + $el.attr('data-overlay-id'));
                    const $buttonArrow = $el.find('.button-arrow-additional');

                    $el.on('click', () => {
                        $target.toggleClass('max-h-32 max-h-120');
                        $overlay.toggleClass('opacity-0 opacity-100');
                        $buttonArrow.toggleClass('rotate-180');
                    });
                });

                setTimeout(() => {
                    (async () => {
                        if ($('.results-update').length) {
                            const quoteIds = [];

                            $('.results-update').each((n, el) => {
                                quoteIds.push(
                                    parseInt($(el).attr('data-quote-id'))
                                );
                            });

                            const [contentDesktop] = await Promise.all([
                                calculatePzpApi.view('results/update', {quoteIds}),
                            ]);

                            resultsContainer.innerHTML = contentDesktop;
                            onUpdate();
                        } else {
                            console.log('done');
                        }
                    })()
                }, 300);
            };

            const [contentDesktop] = await Promise.all([
                calculatePzpApi.view('results', sorted),
            ]);

            resultsContainer.innerHTML = contentDesktop;
            onUpdate();

            anchorScrollComponent(resultsContainer);

            // return updateSteps(data, results);
        };

        const isCategory = (targetCategory, t) => cond(value => category === targetCategory, t, any());

        pzpAddressInputComponent(
            '#individual_postal_city-input',
            '#individual_region-input',
            '#individual_postal_id',
            '#individual_city_id',
            '#individual_region_id',
        );

        const form = formComponent(
            '#vehicle-owner-form',
            {
                fields: [
                    {name: 'individual_first_name', type: 'text', validate: isCategory('individual', required()), onInput},
                    {name: 'individual_last_name', type: 'text', validate: isCategory('individual', required()), onInput},
                    {name: 'individual_identification_card', type: 'text', validate: isCategory('individual', idCardNumber()), onInput},
                    {name: 'individual_identification_number', type: 'text', validate: isCategory('individual', idNumber()), onInput},
                    {name: 'individual_street', type: 'text', validate: isCategory('individual', required()), onInput},
                    {name: 'individual_house_number', type: 'text', validate: isCategory('individual', required()), onInput},
                    {name: 'individual_postal_id', type: 'text', validate: isCategory('individual', required()), onInput},
                    {name: 'individual_city_id', type: 'text', validate: isCategory('individual', required()), onInput},
                    {name: 'individual_postal_city', type: 'text', validate: isCategory('individual', postalCity()), onInput: extendOnInput('individual_region')},
                    {name: 'individual_region_id', type: 'text', validate: isCategory('individual', required()), onInput},
                    {name: 'individual_region', type: 'text', validate: isCategory('individual', required()), onInput},
                    {name: 'individual_country', type: 'text', validate: isCategory('individual', required()), onInput},
                    {name: 'individual_driver_licence_year', type: 'text', validate: isCategory('individual', integer(0,9999)), onInput},
                    // {name: 'individual_insurance_contract', type: 'text', validate: any()},
                    {name: 'individual_same_address', type: 'text', validate: any()},

                    {name: 'entrepreneur_name', type: 'text', validate: isCategory('entrepreneur', required()), onInput},
                    {name: 'entrepreneur_date_of_birth', type: 'text', validate: isCategory('entrepreneur', required()), onInput},
                    {name: 'entrepreneur_ico', type: 'text', validate: isCategory('entrepreneur', required()), onInput},
                    {name: 'entrepreneur_vat', type: 'text', validate: any(), onInput},
                    {name: 'entrepreneur_street', type: 'text', validate: isCategory('entrepreneur', required()), onInput},
                    {name: 'entrepreneur_house_number', type: 'text', validate: isCategory('entrepreneur', required()), onInput},
                    {name: 'entrepreneur_postal_id', type: 'text', validate: isCategory('entrepreneur', required()), onInput},
                    {name: 'entrepreneur_city_id', type: 'text', validate: isCategory('entrepreneur', required()), onInput},
                    {name: 'entrepreneur_postal_city', type: 'text', validate: isCategory('entrepreneur', postalCity()), onInput: extendOnInput('individual_region')},
                    {name: 'entrepreneur_region_id', type: 'text', validate: isCategory('entrepreneur', required()), onInput},
                    {name: 'entrepreneur_region', type: 'text', validate: isCategory('entrepreneur', required()), onInput},
                    {name: 'entrepreneur_country', type: 'text', validate: isCategory('entrepreneur', required()), onInput},
                    // {name: 'entrepreneur_insurance_contract', type: 'text', validate: any()},
                    {name: 'entrepreneur_same_address', type: 'text', validate: any()},

                    {name: 'entity_name', type: 'text', validate: isCategory('entity', required()), onInput},
                    {name: 'entity_ico', type: 'text', validate: isCategory('entity', required()), onInput},
                    {name: 'entity_vat', type: 'text', validate: isCategory('entity', required()), onInput},
                    {name: 'entity_street', type: 'text', validate: isCategory('entity', required()), onInput},
                    {name: 'entity_house_number', type: 'text', validate: isCategory('entity', required()), onInput},
                    {name: 'entity_postal_id', type: 'text', validate: isCategory('entity', required()), onInput},
                    {name: 'entity_city_id', type: 'text', validate: isCategory('entity', required()), onInput},
                    {name: 'entity_postal_city', type: 'text', validate: isCategory('entity', postalCity()), onInput: extendOnInput('individual_region')},
                    {name: 'entity_region_id', type: 'text', validate: isCategory('entity', required()), onInput},
                    {name: 'entity_region', type: 'text', validate: isCategory('entity', required()), onInput},
                    {name: 'entity_country', type: 'text', validate: isCategory('entity', required()), onInput},
                    // {name: 'entity_insurance_contract', type: 'text', validate: any()},
                    {name: 'entity_same_address', type: 'text', validate: any()},
                ],
                onSubmit: async (data) => {
                    data['category'] = category;
                    console.log(data);

                    await calculatePzpApi.vehicleOwner(data);

                    window.dataLayer.push({
                        event: 'pzp_krok_3',
                    });
                    window.hj('event', 'pzp_krok_3');

                    return renderResults(data);
                },
                onErrors: errors => {
                    Object.entries(errors).forEach(([field, isValid]) => {
                        const errorMessage = errorMessages[field];

                        if (!errorMessage) {
                            console.warn('Missing error for field', field);
                            return;
                        }

                        if (errorMessage.root) {
                            const $ele = $(errorMessage.root);
                            const error = $ele.find('.error').get(0);
                            const errorContent = $ele.find('.error-content').get(0);

                            try {
                                if (!isValid) {
                                    error.style.display = 'flex';
                                    errorContent.innerText = errorMessage.message;
                                } else {
                                    error.style.display = 'none';
                                }
                            } catch (e) {
                                console.error('Failed updating error component for field', field);
                            }
                        }
                    });
                },
            }
        )
    };
});

const loadingTemplate = `<div class="flex flex-col items-center justify-center py-32 min-h-screen text-xl font-semibold">
<div>Načítavam ponuky...</div>

<svg width="100" height="100" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" style="background:none;"><defs>
     <filter id="metaballs" x="-100%" y="-100%" width="300%" height="300%" color-interpolation-filters="sRGB">
       <feGaussianBlur in="SourceGraphic" stdDeviation="3.5"></feGaussianBlur>
<feComponentTransfer result="cutoff">
  <feFuncA type="linear" slope="20" intercept="-6"></feFuncA>
</feComponentTransfer>
     </filter>
   </defs><g filter="url(#metaballs)"><g transform="translate(50 50)">
<g transform="rotate(347.4)">
  <circle cx="22" cy="0" r="4.592" fill="#322c6d">
    <animate attributeName="r" keyTimes="0;0.5;1" values="4.2;9.799999999999999;4.2" dur="10s" repeatCount="indefinite" begin="-10s"></animate>
  </circle>
  <animateTransform attributeName="transform" type="rotate" keyTimes="0;1" values="0;360" dur="10s" repeatCount="indefinite" begin="0s"></animateTransform>
</g>
</g><g transform="translate(50 50)">
<g transform="rotate(54.8)">
  <circle cx="22" cy="0" r="7.47289" fill="#494e8a">
    <animate attributeName="r" keyTimes="0;0.5;1" values="4.2;9.799999999999999;4.2" dur="5s" repeatCount="indefinite" begin="-8.88888888888889s"></animate>
  </circle>
  <animateTransform attributeName="transform" type="rotate" keyTimes="0;1" values="0;360" dur="5s" repeatCount="indefinite" begin="-1.1111111111111112s"></animateTransform>
</g>
</g><g transform="translate(50 50)">
<g transform="rotate(202.2)">
  <circle cx="22" cy="0" r="6.75733" fill="#e4a549">
    <animate attributeName="r" keyTimes="0;0.5;1" values="4.2;9.799999999999999;4.2" dur="3.3333333333333335s" repeatCount="indefinite" begin="-7.777777777777778s"></animate>
  </circle>
  <animateTransform attributeName="transform" type="rotate" keyTimes="0;1" values="0;360" dur="3.3333333333333335s" repeatCount="indefinite" begin="-2.2222222222222223s"></animateTransform>
</g>
</g><g transform="translate(50 50)">
<g transform="rotate(69.6)">
  <circle cx="22" cy="0" r="9.50133" fill="#322c6d">
    <animate attributeName="r" keyTimes="0;0.5;1" values="4.2;9.799999999999999;4.2" dur="2.5s" repeatCount="indefinite" begin="-6.666666666666667s"></animate>
  </circle>
  <animateTransform attributeName="transform" type="rotate" keyTimes="0;1" values="0;360" dur="2.5s" repeatCount="indefinite" begin="-3.3333333333333335s"></animateTransform>
</g>
</g><g transform="translate(50 50)">
<g transform="rotate(17)">
  <circle cx="22" cy="0" r="8.64889" fill="#494e8a">
    <animate attributeName="r" keyTimes="0;0.5;1" values="4.2;9.799999999999999;4.2" dur="2s" repeatCount="indefinite" begin="-5.555555555555555s"></animate>
  </circle>
  <animateTransform attributeName="transform" type="rotate" keyTimes="0;1" values="0;360" dur="2s" repeatCount="indefinite" begin="-4.444444444444445s"></animateTransform>
</g>
</g><g transform="translate(50 50)">
<g transform="rotate(44.4)">
  <circle cx="22" cy="0" r="9.31467" fill="#e4a549">
    <animate attributeName="r" keyTimes="0;0.5;1" values="4.2;9.799999999999999;4.2" dur="1.6666666666666667s" repeatCount="indefinite" begin="-4.444444444444445s"></animate>
  </circle>
  <animateTransform attributeName="transform" type="rotate" keyTimes="0;1" values="0;360" dur="1.6666666666666667s" repeatCount="indefinite" begin="-5.555555555555555s"></animateTransform>
</g>
</g><g transform="translate(50 50)">
<g transform="rotate(151.8)">
  <circle cx="22" cy="0" r="5.18933" fill="#322c6d">
    <animate attributeName="r" keyTimes="0;0.5;1" values="4.2;9.799999999999999;4.2" dur="1.4285714285714286s" repeatCount="indefinite" begin="-3.3333333333333335s"></animate>
  </circle>
  <animateTransform attributeName="transform" type="rotate" keyTimes="0;1" values="0;360" dur="1.4285714285714286s" repeatCount="indefinite" begin="-6.666666666666667s"></animateTransform>
</g>
</g><g transform="translate(50 50)">
<g transform="rotate(339.2)">
  <circle cx="22" cy="0" r="9.77511" fill="#494e8a">
    <animate attributeName="r" keyTimes="0;0.5;1" values="4.2;9.799999999999999;4.2" dur="1.25s" repeatCount="indefinite" begin="-2.2222222222222223s"></animate>
  </circle>
  <animateTransform attributeName="transform" type="rotate" keyTimes="0;1" values="0;360" dur="1.25s" repeatCount="indefinite" begin="-7.777777777777778s"></animateTransform>
</g>
</g><g transform="translate(50 50)">
<g transform="rotate(246.6)">
  <circle cx="22" cy="0" r="7.728" fill="#e4a549">
    <animate attributeName="r" keyTimes="0;0.5;1" values="4.2;9.799999999999999;4.2" dur="1.1111111111111112s" repeatCount="indefinite" begin="-1.1111111111111112s"></animate>
  </circle>
  <animateTransform attributeName="transform" type="rotate" keyTimes="0;1" values="0;360" dur="1.1111111111111112s" repeatCount="indefinite" begin="-8.88888888888889s"></animateTransform>
</g>
</g></g></svg>
<div class="text-base">
Môže to chvíľu trvať 🤖
</div>
</div>`;
